import { Box, Typography } from "@mui/material"

export function PatchNote3_3(): React.JSX.Element {
  return (
    <>
      <Typography variant="body1" gutterBottom>
        🎉 Les nouveautés de la{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          version 3.3
        </Box>
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        • Dans shot,{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          nouveau graphique permettant de voir la distribution des types de FDES
        </Box>{" "}
        (individuelles, collectives, par défaut).
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        • Possibilité de{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          replier le menu de gauche
        </Box>{" "}
        afin que la fenêtre de configuration / dashboard prenne tout l'espace.
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }} color="">
        • Possibilité de{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          rechercher par organisme déclarant
        </Box>{" "}
        lors de la personnalisation d'une fiche FDES .
      </Typography>
    </>
  )
}
